import axios, { AxiosResponse } from 'axios'
import { ICashCollectionModel } from './CashCollectionModel'
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'


const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')


export const CASH_COLLECTION_CREATE_URL = `${API_URL}api/v1/customer/cashcollection/create`
export const CASH_COLLECTION_ALL_URL = `${API_URL}api/v1/customer/cashcollection/all`
export const CASH_COLLECTION_DELETE_URL = `${API_URL}api/v1/customer/cashcollection/delete/`
export const CASH_COLLECTION_UPDATE_URL = `${API_URL}api/v1/customer/cashcollection/update/`


export function createCashCollection(payload: ICashCollectionModel) {
  return axios.post(CASH_COLLECTION_CREATE_URL, payload)
}

export function updateCashCollection(payload: ICashCollectionModel) {
  return axios.patch(CASH_COLLECTION_UPDATE_URL, payload)
}

export function deleteCashCollection(id: number | string) {
  return axios.delete(CASH_COLLECTION_DELETE_URL + id)
}

export async function getAllCashCollections(
  page = 0,
  size = 10,
  sort?: string,
  order?: 'asc' | 'desc'
) {
  const params: any = { page, size }
  if (sort) {
    params.sort = sort
    params.order = order ?? 'desc'
  }
  return axios.get(CASH_COLLECTION_ALL_URL, { params })
}